import React, { useCallback, useContext } from 'react'
import ModalContext from 'contexts/ModalContext'
import getLoyaltyBenefitInfoModal from 'loyalty/lib/getLoyaltyBenefitInfoModal'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import Clickable from 'components/Common/Clickable'

interface Props {
  inclusionId: string
}

function LoyaltyBenefitInfoIcon({ inclusionId }: Props) {
  const showModal = useContext(ModalContext)
  const InfoModal = getLoyaltyBenefitInfoModal(inclusionId)

  const handleClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (InfoModal) {
      showModal(<InfoModal />)
    }
  }, [showModal, InfoModal])

  if (!InfoModal) return null

  return (
    <Clickable onClick={handleClick} aria-label="Learn more about loyalty benefit">
      <LineInfoCircleIcon size="S" colour="neutral-two" />
    </Clickable>
  )
}

export default LoyaltyBenefitInfoIcon
